/* Kyodan - Temporary patch for French thumbnails not grouping

   Todo: Adjust slider to prevent clipping if thumb #1 is hidden
*/

function gatherThumbs(){
    let bodyTag = document.querySelector('body');

    if (bodyTag.classList.contains('template-product')){
        let loadGroup = document.querySelector('.starting-slide').dataset.group;

        document.querySelectorAll('.product__thumb-item').forEach(thumb => {
            thumb.classList.toggle('hide', thumb.dataset.group !== loadGroup);
        });
    }
}

// Kyodan - Fallback 'gathering' for unilingual alt text
const photosTag = document.querySelector('[data-legacy-alt]');
if (photosTag){
  document.addEventListener('variant:change', function(evt){
       // Kyodan - Adding support for TinySEO whitespace error
       // var alt = evt.detail.variant.featured_image.alt.replace('#', '');
       var alt = evt.detail.variant.featured_image.alt.split('#')[1].replace(/\s+/g, '');
  
       document.querySelectorAll('.product__thumb-item').forEach(thumb => {
         thumb.classList.toggle('hide', thumb.dataset.group !== alt);
         console.log('dataset', thumb.dataset.group);
       });
  });
}
  
// Kyodan - Custom table striping (on odd rows)
document.querySelectorAll('.rte table').forEach(table => {
    let rowCount = 0;
    table.querySelectorAll('tr').forEach(tr => {
        if (rowCount % 2 === 0) {
            tr.classList.add('striped');
        }
        rowCount++;
    });
});